var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'radio-item': true,
    },on:{"click":_vm.onClick}},[_c('Icon',{staticClass:"radio-item__radio",attrs:{"type":_vm.checked ? 'radio_checked_dark' : 'radio',"width":25,"height":25}}),_c('div',{staticClass:"radio-item__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('Icon',{staticClass:"radio-item__icon",attrs:{"type":_vm.icon,"width":22,"height":22}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }